<template>
	<div class="details">
		<div class="head flex end-v" :style="{backgroundImage:`url(${kinectInfo.cover})`}">
			<div class="score flex between">
				<span :data-score="kinectInfo.exerciseAvg||0" class="flex center">练习平均分</span>
				<!-- v-if指定课 -->
				<span v-if="kinectInfo.isTrain" :data-score="kinectInfo.trainAvg||0" class="flex center">训练平均分</span>
			</div>
		</div>

		<div class="info">
			<p class="title">{{kinectInfo.name}}</p>
			<span class="tag flex center" :data-group="kinectInfo.studentGroup"></span>
			<div class="desc">{{kinectInfo.remarks}}</div>
		</div>
		<div class="diver"></div>

		<div v-if="kinectInfo.isTrain" class="info">
			<p class="tips">该视频为老师指定打卡视频</p>
			<div class="count flex between">
				<div class="flex center">
					<span class="label">目标</span>
					<span :style="{color:'rgba(255, 162, 22, 1)'}" class="num">{{kinectInfo.targetCount||0}}</span>
				</div>
				<div class="flex center">
					<span v-if="!hasDone" class="label">已训练</span>
					<span v-if="!hasDone" class="num">{{kinectInfo.completeCount||0}}</span>
					<span v-if="hasDone" class="done">您已经完成目标</span>
				</div>
			</div>
		</div>
		<div v-if="kinectInfo.isTrain" class="diver"></div>

		<div class="info">
			<p class="title">
				课程内容
				<span>（{{kinectInfo.actionNum||0}}个动作）</span>
			</p>
			<div class="scroll-view flex start">
				<div v-for="(item,index) in kinectInfo.aiVideos" :key="index" class="item">
					<div v-if="item.type==0" :style="{backgroundImage:`url(${tttimg})`}" class="content flex end-v">
						<p class="flex between">
							{{item.name}}
							<span>{{item.durationOrCount||0}}</span>
						</p>
					</div>
					<div v-if="item.type==1" class="reset flex center">
						<span>休息</span>
						<span>{{item.durationOrCount}}″</span>
					</div>
				</div>
			</div>
			<p class="tips">训练时请尽量与示范视频的人物角度保持一致，角度差异会影响评分。</p>
		</div>

		<div v-if="$route.query.homeworkid" class="btns flex between">
			<button @click="toPlay(1)" class="btn-full">去完成作业</button>
		</div>

		<div v-else class="btns flex between">
			<button @click="toPlay(1)" class="btn-full btn-l">自主练习</button>
			<!-- 指定课需要打卡训练 -->
			<button v-if="kinectInfo.isTrain" @click="toPlay(0)" class="btn-full btn-r">打卡训练</button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tttimg: require("@img/modular_ai.png"),
			kinectInfo: {},
		};
	},

	mounted() {
		this.getDetails();
	},

	computed: {
		hasDone() {
			let { targetCount, completeCount } = this.kinectInfo || {};
			return completeCount>=targetCount;
		},
	},

	methods: {
		toPlay(type) {
			this.$router.push({
				path: "/student/sports/kinect/play",
				query: { type: type, kinectInfo: this.kinectInfo,homeworkid:this.$route.query.homeworkid||"" },
			});
		},

		async getDetails() {
			try {
				let { success, message, result } = await this.$http.get(
					`h5/examineTrain/getVideoCollectionInfo?aiVideoCollectionId=${this.$route.query.kinectId}`
				);
				if (!success) throw new Error(message);
				result.actionNum =
					result.aiVideos.filter((item) => item.type == 0)?.length ||
					0;
				result.exerciseAvg = result.exerciseAvg?result.exerciseAvg.toFixed(2):'0.00';
				result.trainAvg = result.trainAvg?result.trainAvg.toFixed(2):'0.00';
				this.kinectInfo = result;
			} catch (error) {
				console.log("getRaceList", error);
			}
		},
	},
};
</script>

<style scoped lang="less">
.details {
	height: 100%;
	.head {
		height: 210 / @rem;
		background-color: rgba(158, 148, 148, 1);
		background-size: cover;
		.score {
			padding: 7 / @rem 23 / @rem;
			font-size: 10 / @rem;
			letter-spacing: 1 / @rem;
			color: white;
			background: linear-gradient(
				180deg,
				rgba(0, 0, 0, 0) 0%,
				rgba(0, 0, 0, 0.5) 100%
			);

			span::before {
				content: attr(data-score);
				font-size: 28 / @rem;
				font-weight: bold;
			}
		}
	}
	.info {
		padding: 10 / @rem 19 / @rem 5 / @rem;
		p {
			&.title {
				font-size: 17 / @rem;
				font-weight: bold;
				span {
					font-size: 12 / @rem;
					color: rgba(31, 30, 29, 0.3);
				}
			}
			&.tips {
				padding-bottom: 10 / @rem;
				font-size: 12 / @rem;
				color: rgba(49, 49, 49, 0.3);
			}
		}

		div {
			&.desc {
				font-family: Microsoft YaHei, Microsoft YaHei;
				color: rgba(49, 49, 49, 0.5);
			}
			&.count {
				height: 56 / @rem;
				> div {
					width: 50%;
					height: 100%;
					&:last-child {
						border-left: 1 / @rem solid rgba(31, 30, 29, 0.3);
					}
				}
			}
		}
		span {
			&.label {
				font-weight: bold;
				color: rgba(49, 49, 49, 1);
			}
			&.num {
				font-size: 24 / @rem;
				font-weight: bold;
				color: rgba(49, 49, 49, 0.3);
				&::after {
					content: "次";
					font-size: 12 / @rem;
					font-weight: bold;
					padding-left: 2 / @rem;
					color: rgba(49, 49, 49, 1);
				}
			}
			&.done {
				font-weight: bold;
				color: rgba(31, 30, 29, 0.3);
			}
		}

		span.tag {
			padding: 5 / @rem;
			width: 47 / @rem;
			height: 18 / @rem;
			border-radius: 3 / @rem;
			margin: 8 / @rem 0;
			font-size: 12 / @rem;
		}
	}

	.btns {
		padding: 50 / @rem 17 / @rem 20 / @rem;
		.btn-l {
			min-width: 125 / @rem;
			background: linear-gradient(180deg, #fea42e 0%, #e95000 100%);
		}
		.btn-r {
			min-width: 200 / @rem;
			margin-left: 17 / @rem;
			background: linear-gradient(180deg, #fec633 0%, #ffa216 100%);
		}
	}

	.scroll-view {
		margin: 10 / @rem 0;
		overflow-x: auto;
		.item {
			> div {
				height: 67 / @rem;
				margin-right: 7 / @rem;
				background-color: rgba(254, 198, 51, 0.1);
				border-radius: 2 / @rem;
				overflow: hidden;
				&.content {
					width: 119 / @rem;
					background-repeat: no-repeat;
					background-size: cover;
					p {
						padding: 4 / @rem;
						background: linear-gradient(
							180deg,
							rgba(0, 0, 0, 0) 0%,
							rgba(0, 0, 0, 0.5) 100%
						);
						font-size: 10 / @rem;
						font-weight: bold;
						letter-spacing: 1 / @rem;
						color: white;
						span {
							font-weight: 400;
							color: rgba(254, 198, 51, 1);
							&::after {
								content: "次";
								font-size: 8 / @rem;
								padding-left: 1 / @rem;
								color: white;
							}
						}
					}
				}
				&.reset {
					color: rgba(255, 162, 22, 1);
					width: 31 / @rem;
					span:first-child {
						font-size: 12 / @rem;
					}
					span:last-child {
						font-size: 10 / @rem;
					}
				}
			}
			&:last-child {
				margin-right: 0;
			}
		}
	}
}
</style>
